// Placeholder images
// They are all flat grey squares

export default {
    ['40x40']: ' data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoAQMAAAC2MCouAAAAA1BMVEWKioqH2blzAAAAC0lEQVQI12MYYQAAAPAAAU6V2N8AAAAASUVORK5CYII=',
    ['300x300']: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQMAAABDsxw2AAAAA1BMVEXj6OlDr3AbAAAAIklEQVR4Ae3BMQEAAADCIPunNsU+YBkAAAAAAAAAAAAAAA4ttAABERf5rAAAAABJRU5ErkJggg==',
    ['400x400']: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQAQMAAAC6caSPAAAAA1BMVEVtbW0EJW2mAAAAKklEQVR42u3BgQAAAADDoPtTH2AK1QAAAAAAAAAAAAAAAAAAAAAAAACAOE+wAAFrRnPdAAAAAElFTkSuQmCC',
};
